<script lang="ts">
  import { fade } from 'svelte/transition';
  export let label: string;
  export let key: string;
  export let value: string;
  export let error: boolean = false;
</script>

<style>
  input {
    background-color: rgba(0,0,0,.5 );
    color: white;
    border: 1px solid transparent;
    outline: none;
    border-radius: 5px;
    width: 100%;
    display: block;
    padding: .8em;
  }
  input:hover {
    border: 1px solid black;
  }
  input:focus {
    border: 1px solid white;
  }
  ::placeholder {
    color:rgba(255, 255, 255, .7);
  }
  span.error {
    position: absolute;
    right: 0;
    top: 0;
    color: white;
    background-color: red;
    padding: 4px;
    border-radius: 4px;
  }
</style>

<div style="position: relative">
<input name={key} type="text" placeholder={label} bind:value={value}>
{#if error}
	<span in:fade class="error">Verplicht</span>
{/if}

</div>
